import { AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import desktopImage from '../../../assets/images/backoffice/flipMe/flipmeCards.png';
import mobileImage from '../../../assets/images/backoffice/flipMe/flipmeCardsMobile.png';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { AnimatedTab } from '../../../components/animation/AnimatedTab';
import { CheckText } from '../../../components/common/CheckText';
import { Hub } from '../../../components/common/Hub/Hub';
import Spinner from '../../../components/common/Spinner';
import { getUserTickets } from '../../../slices/auth-slice';
import { H3, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed, PageTitle } from '../../../styles/GlobalComponents';
import { color, lightTheme } from '../../../styles/GlobalStyles';
import { Desktop, Mobile } from '../../Kyc/KycStyled';
import { getFlipmeCards } from '../Marketplace.actions';
import {
  StakingHubDetailsStyled,
  Tab,
  Tabs,
  TabsWrapper
} from '../Marketplace.styled';
import { PurchasePackageAndCombo } from '../PurchasePackageAndCombo/PurchasePackageAndCombo';
// import { CountdownComponent } from './countdown';

const tabs = [
  { name: '1', value: '1' },
  { name: '4+1 Free', value: '4+1' },
  { name: '12+5 Free', value: '12+5' }
];

export const FlipmeCards = () => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState('1');

  const { loading, hubs } = useSelector((state) => state.marketplace);

  useEffect(() => {
    dispatch(getFlipmeCards());
    dispatch(getUserTickets());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  const filteredHubs = hubs.filter((item) => item.packageGroup === tab);

  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      <Desktop>
        <section style={{ position: 'relative' }}>
          <img src={desktopImage} alt='trading' style={{ width: '100%' }} />
        </section>
      </Desktop>

      <Mobile>
        <section style={{ position: 'relative' }}>
          <img src={mobileImage} alt='trading' style={{ width: '100%' }} />
        </section>
      </Mobile>

      <P1 mb='20' mt='40'>
        Ready to revolutionize how you pay?
      </P1>
      <P1 mb='20'>Join FlipMe and experience the future of global payments!</P1>
      <P1 mb='40'>
        Powered by crypto, FlipMe Cards let you spend anywhere in the world with
        ease and security. Take control of your finances and unlock limitles
        possibilities!
      </P1>

      <PageTitle>
        LAUNCH PROMOTION - Buy 4, Get 1 Free. Buy 12, Get 5 Free!
      </PageTitle>
      <P2 color={lightTheme.colors.neutral500}>
        *Cards are valid for 2 years from the date you receive them. There is no
        monthly membership for MaVie Global members that purchase the cards
        during December 2024.
      </P2>

      <Flexed mt='40' rowSM gap={selectedHub !== null ? '100px' : '0'}>
        <Flexed
          column
          width={selectedHub !== null ? '65%' : '100%'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          <Flexed end mb='20' center>
            <P3 mr='20'>Choose Promotion:</P3>

            <Tabs>
              {tabs.map(({ value, name }, i) => (
                <Tab
                  key={i}
                  selected={value === tab}
                  onClick={() => {
                    setTab(value);
                    if (value === '1') {
                      setSelectedHub(hubs?.[0]);
                    } else if (value === '4+1') {
                      setSelectedHub(hubs?.[4]);
                    } else {
                      setSelectedHub(hubs?.[8]);
                    }
                  }}>
                  {name}
                </Tab>
              ))}
            </Tabs>
          </Flexed>
          {filteredHubs?.map((hub) => {
            const {
              id,
              image,
              name,
              price,
              priceToShow,
              subtitle,
              subtitle2,
              tickets
            } = hub;

            return (
              <Hub
                key={id}
                image={image}
                showTickets={false}
                title={name}
                price={price}
                priceToShow={priceToShow}
                subtitle={subtitle}
                tickets={tickets}
                onClick={() => handleSeeDetails(hub)}
                selected={selectedHub?.id === id}
                button={
                  <Button
                    w='200px'
                    wSM='100%'
                    onClick={() => handleSelectPackage(hub)}
                    negative={selectedHub?.id !== id}>
                    Select Card
                  </Button>
                }
                stakingHubDetails={<StakingHubDetails hub={hub} />}
              />
            );
          })}
        </Flexed>
        <Flexed
          desktop
          column
          width={selectedHub !== null ? '35%' : '0'}
          widthSM='100%'
          style={{ transition: 'width 300ms ease' }}>
          <div
            style={{
              position: 'sticky',
              top: 200
            }}>
            <AnimatePresence exitBeforeEnter>
              {selectedHub?.id &&
                hubs?.map((hub, i) => {
                  if (hub?.id === selectedHub?.id) {
                    return (
                      <AnimatedTab key={i}>
                        <H3 mb='4' color={color.colors.primary900}>
                          {hub?.name}
                        </H3>
                        <StakingHubDetailsStyled>
                          <StakingHubDetails hub={hub} />
                        </StakingHubDetailsStyled>
                      </AnimatedTab>
                    );
                  } else return null;
                })}
            </AnimatePresence>
          </div>
        </Flexed>
      </Flexed>

      <PurchasePackageAndCombo
        selectedPackage={selectedHub}
        modal={modal}
        setModal={setModal}
      />
    </AnimatedDashboard>
  );
};

const StakingHubDetails = ({ hub }) => {
  return (
    <div>
      <P1 semiBold color={color.colors.neutral500} mb='12'>
        Card Benefits
      </P1>
      {hub?.whaleBenefits?.map((benefit, i) => (
        <div key={i}>
          <CheckText text={benefit} />
        </div>
      ))}
    </div>
  );
};
